import React from 'react'

export const Notfoundpage = () => {
  return (
    <div className='scrollbar-hide flex justify-center items-center h-screen bg-green-400 text-white'>
      <div className='flex text-center space-x-1'>
        <div>
          <p className='text-lg font-bold border-r border-white pr-4'>404</p>
        </div>
        <div>
          <p className='text-lg pl-4'>This page could not be found.</p>
        </div>
      </div>
    </div>
  )
}
